
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useQuestBoostEdit } from '@/modules/quest/boost/model/edit';
import { timeUnits } from '@/common/utils/helpers';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';

export default defineComponent({
    name: ROUTE_NAME_QUEST.BOOST.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, actions, iapOptions } = useQuestBoostEdit();

        return { v$, model, actions, iapOptions, timeUnits };
    }
});
